// vuetify.js
import 'vuetify/styles'; // Global CSS
import { createVuetify } from 'vuetify';

const vuetify = createVuetify({
  // Add your Vuetify theme, components, or configuration here
});

export default vuetify;